interface HighlightMatchProps {
  text: string;
  query: string;
}

/**
 * Bolds the first occurrence of `query` inside plain (non-markdown) text, e.g. a question title.
 *
 * Always renders as a single wrapping element (never a bare Fragment): this component is used
 * inside AccordionTrigger's `flex ... gap-4` row, and a Fragment's children would each become
 * their own flex item — `gap-4` then inserts a visible gap between the text-before/match/text-after
 * runs, visibly splitting words apart around the highlight.
 */
export function HighlightMatch({ text, query }: HighlightMatchProps) {
  const needle = query.trim();
  if (!needle) {
    return <span>{text}</span>;
  }

  const index = text.toLowerCase().indexOf(needle.toLowerCase());
  if (index === -1) {
    return <span>{text}</span>;
  }

  const before = text.slice(0, index);
  const match = text.slice(index, index + needle.length);
  const after = text.slice(index + needle.length);

  return (
    <span>
      {before}
      <span className="text-yellow-500">{match}</span>
      {after}
    </span>
  );
}
